(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-components/assets/javascripts/views/parts/pay-button-display.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-components/assets/javascripts/views/parts/pay-button-display.js');
"use strict";

const _svs$ui = svs.ui,
  ReactButton = _svs$ui.ReactButton,
  ReactIcon = _svs$ui.ReactIcon;
const Betslip = svs.components.tipsen.betslipComponents.Betslip;
const PayButtonDisplay = _ref => {
  let betslipLabel = _ref.betslipLabel,
    handlePay = _ref.handlePay,
    hasScrollDownIcon = _ref.hasScrollDownIcon,
    isDisabled = _ref.isDisabled,
    _ref$isFocused = _ref.isFocused,
    isFocused = _ref$isFocused === void 0 ? true : _ref$isFocused;
  return React.createElement(ReactButton, {
    "aria-label": betslipLabel,
    block: true,
    "data-testid": "payButton",
    disabled: isDisabled,
    focus: isFocused,
    iconPosition: "left",
    id: "payButton",
    onClick: handlePay,
    type: "button"
  }, betslipLabel, hasScrollDownIcon ? React.createElement(ReactIcon, {
    className: "margin-left",
    color: "white",
    icon: "scroll-down"
  }) : '');
};
Betslip.PayButtonDisplay = PayButtonDisplay;

 })(window);